// Module startup
import { init as zipChecker } from './_zipChecker';

const init = () => {
    const compareProvidersComponents = document.querySelectorAll(
        '.compare_providers_component'
    );
    if (compareProvidersComponents.length > 0) {
        compareProvidersComponents.forEach((component) => {
            const observer = new IntersectionObserver(
                ([e]) =>
                    e.target.classList.toggle(
                        'add-shadow',
                        e.intersectionRatio < 1
                    ),
                { threshold: [1] }
            );

            const compare_shadow = component.querySelector('.compare_shadow');
            observer.observe(compare_shadow);

            component
                .querySelectorAll('.compare_providers--2 .compare_logo')
                .forEach((compare_logo) => {
                    if (compare_logo) {
                        observer.observe(compare_logo);
                    }
                });

            component
                .querySelectorAll('.compare_providers_select')
                .forEach((el) => {
                    el.addEventListener('change', (e) => {
                        const compareSide = el.name;
                        const selected = e.target.value;
                        const compareData = compareArray[selected]; // eslint-disable-line no-undef
                        let otherSide = 'compare_providers--2';

                        if (compareSide === 'compare_providers--2') {
                            otherSide = 'compare_providers--1';
                        }

                        component
                            .querySelectorAll(
                                // service type
                                '.' +
                                    otherSide +
                                    ' .compare_providers_select option'
                            )
                            .forEach((opt) => {
                                if (opt.value === selected) {
                                    opt.disabled = true;
                                } else if (opt.value !== '') {
                                    opt.disabled = false;
                                }
                            });

                        // change all the values
                        if (compareData.service_type !== undefined) {
                            component.querySelector(
                                // service type
                                '.' + compareSide + ' .compare_service_type_p'
                            ).style.display = 'block';
                            component.querySelector(
                                // service type
                                '.' + compareSide + ' .compare_service_type'
                            ).innerHTML = compareData.service_type;
                            if (compareData.service_type_icon !== false) {
                                component.querySelector(
                                    // service type icon
                                    '.' +
                                        compareSide +
                                        ' .compare_service_type_icon'
                                ).style.display = 'inline-block';
                                component.querySelector(
                                    // service type icon
                                    '.' +
                                        compareSide +
                                        ' .compare_service_type_icon'
                                ).src = compareData.service_type_icon;
                            } else {
                                component.querySelector(
                                    // service type icon
                                    '.' +
                                        compareSide +
                                        ' .compare_service_type_icon'
                                ).style.display = 'none';
                            }
                        } else {
                            component.querySelector(
                                // service type
                                '.' + compareSide + ' .compare_service_type_p'
                            ).style.display = 'none';
                        }
                        component.querySelector(
                            // logo
                            '.' + compareSide + ' .compare_logo'
                        ).innerHTML = compareData.logo;
                        component.querySelector(
                            // star rating
                            '.' + compareSide + ' .compare_stars'
                        ).innerHTML = compareData.stars;
                        component.querySelector(
                            // customer rating
                            '.' + compareSide + ' .compare_rating_link'
                        ).href = compareData.rating_link;
                        component.querySelector(
                            // view plans button
                            '.' + compareSide + ' .compare_viewplans'
                        ).innerHTML = compareData.view_plans;

                        const zipCheckerForm = component.querySelector(
                            '.' + compareSide + ' .zip-checker'
                        );
                        if (zipCheckerForm) {
                            zipChecker(zipCheckerForm);
                        }

                        component.querySelector(
                            // download speed
                            '.' + compareSide + ' .compare_speed'
                        ).innerHTML = `${compareData.speed} Mbps`;
                        component.querySelector(
                            // price
                            '.' + compareSide + ' .compare_price'
                        ).innerHTML = `$${compareData.price}/mo.`;
                        if (compareData.microsite === 'editorial') {
                            // read review link
                            component.querySelector(
                                '.' + compareSide + ' .compare_review'
                            ).innerHTML = `<a href="/${compareData.brand_slug}" class="compare_review">Read ${compareData.name} Review</a>`;
                        } else {
                            component.querySelector(
                                '.' + compareSide + ' .compare_review'
                            ).innerHTML = '';
                        }
                        if (compareData.disclaimer) {
                            // provider disclaimers
                            component.querySelector(
                                '.' + compareSide + ' .compare_disclaimer'
                            ).innerHTML = `*${compareData.disclaimer}`;
                            component.querySelector(
                                '.' + compareSide + ' .compare_disclaimer_icon'
                            ).style.display = 'inline-block';
                            component.querySelector(
                                '.' + compareSide + ' .compare_disclaimer_icon'
                            ).innerHTML = '*';
                        } else {
                            component.querySelector(
                                '.' + compareSide + ' .compare_disclaimer'
                            ).innerHTML = '';
                            component.querySelector(
                                '.' + compareSide + ' .compare_disclaimer_icon'
                            ).style.display = 'none';
                        }
                        // add animation
                        component
                            .querySelector('.' + compareSide)
                            .classList.add('animateIt');

                        setTimeout(() => {
                            component
                                .querySelector('.' + compareSide)
                                .classList.remove('animateIt');
                        }, 300);
                    });
                });
        });
    }
};

export { init };
